








































import { Component, Vue, Prop } from 'vue-property-decorator';
import { GQL_newInvoiceData_newInvoice } from '@/queries/__generated__/newInvoiceData';
import i18n from '@/i18n';
import MailButton from '../../Shared/MailButton.vue';
import { GQL_emailInvoice } from '@/queries/__generated__/emailInvoice';
import { emailRecipients } from '@/app/Invoice';
import { watchInvoice } from '@/app/invoiceWatch';
import gql from 'graphql-tag';

const INVOICE_MAIL = gql`
  mutation emailInvoice($invoiceId: ID!, $recipients: [String!]!, $shouldSendAttachments: Boolean!) {
    emailInvoice(
      input: {
        invoiceId: $invoiceId,
        recipients: $recipients,
        shouldSendAttachments: $shouldSendAttachments,
      }
    ) {
      logInvoiceMail {
        id destination sentAt
        deliveryMethod
        sentBy { id name }
        deliveryStatus
        deliveryError
        attachmentsCount
      }
    }
  },
`;

@Component ({
  components: {
    MailButton,
  },
})
export default class InvoiceMailButton extends Vue {
  @Prop() invoice!: GQL_newInvoiceData_newInvoice;
  @Prop({ type: Boolean, default: false }) addCompanyMailToCC!: boolean;
  @Prop({ type: String, default: 'standard' }) color!: string;

  private INVOICE_MAIL = INVOICE_MAIL;

  private recipient: string | null = "";
  private copies: string[] = [];
  private shouldSendAttachments = false;

  private mounted() {
    this.resetRecipients();
  }

  private resetRecipients() {
    [ this.recipient, this.copies ] = emailRecipients(
      this.invoice.customer.email || false,
      this.addCompanyMailToCC,
      this.invoice.supplierParty.email || false,
    );
  }

  private onSent(data: GQL_emailInvoice) {
    this.$sMessage.success(i18n.t('Document.Email.sendSuccess'));
    // the mail is handed to a background job, so listen for how it goes
    watchInvoice(this.invoice.id);
    this.$set(this.invoice, 'emailLogs', this.invoice.emailLogs.concat(data.emailInvoice!.logInvoiceMail));
    this.resetRecipients();
    this.$emit('sent');
  }
}
